<style>
    .clearfix:after {
        content: '';
        display: block;
        visibility: hidden;
        clear: both;
    }

    .select-container {
        padding: 15px 2% 3px;
    }

    .select-left {
        float: left;
        display: table;
    }

    .select-left > div {
        vertical-align: top;
    }

    .select-left > div:not(:last-child) {
        margin-right: 5px;
    }

    .select-right {
        float: right;
    }
</style>

<template>
    <div>
        <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
            <span style="font-size:30px;font-weight:bold;">赛门铁克杀毒软件—mac客户端</span><br><br>
            <span style="color:red">请注意：在安装之前请务必保存已有工作，安装完成后必须重启电脑！！</span><br>
            <span style="color:red">请注意：在安装之前请务必保存已有工作，安装完成后必须重启电脑！！</span><br>
            <span style="color:red">请注意：在安装之前请务必保存已有工作，安装完成后必须重启电脑！！</span><br><br>
            <span style="font-size:25px;font-weight:bold;">一、安装前注意事项</span><br><br>
            <div style="background:#FFF5EE">请先判断Mac系统版本方法,是否符合软件要求<br>
                <span style="color:red">当前支持系统版本号>=10.10</span></div>
            <br>
            查看当前系统版本的方法：<br>
            1.点击左上角“苹果”图标，点击“关于本机”<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic1.png" width=280px height=300px><br>
            2.在弹出的窗口中可以看到版本号<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic2.png" width=500px height=300px><br>
            3.若不符合要求的系统版本，需将系统升级，升级方式：请联系6000协助<br>
            <span style="font-size:25px;font-weight:bold;">二、软件下载地址</span><br>
            <p>访问IT门户：<a data-auto_update="0" href="https://itportal.sankuai.com/" style="color:#1890ff" class="ct-link"
                         target="_blank" rel="noopener">https://itportal.sankuai.com</a></p>
            <p>点击SEP图标，根据操作系统类型选择安装包：</p>
            <p><img src="../assets/saimenInstallForMac/saimenInstallForMac_pic16.png" width=700px height=380px></p>
            <span style="font-size:25px;font-weight:bold;">三、安装方法</span><br><br>
            1.下载程序后，解压文件，双击 symantec.app， 若弹出以下窗口<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic3.png" width=500px height=200px><br>
            2.打开 “系统偏好设置” -“安全性与隐私”，选择“通用”，点击 “仍要打开”<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic4.png" width=500px height=400px><br>
            3.再次双击Symantec.app-出现如下界面后-点击“开始安装”<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic5.png" width=500px height=300px><br>
            4.会弹出窗口提示输入mis账号，请输入您的mis账号（不是邮箱，不是中文）<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic6.png" width=380px height=120px><br>
            5.输入mis账号后，要求输入本机的账号和密码（非mis账号）<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic7.png" width=450px height=320px><br>
            6.输入用户名和密码后，程序会继续安装。安装过程会持续3-5分钟，请耐心等待。<br>
            7.<span style="color:red">安装过程中，程序会自动识别您的mis账号并注册，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面</span><br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic8.png" width=550px height=320px><br>
            8.若注册成功，页面显示如下：<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic9.png" width=550px height=220px><br>
            9.软件安装完成后，界面如下：<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic10.png" width=550px height=300px><br>
            10.点击立即重启即可。<br>
            <span style="color:red">请注意：点击“立即重启”之后，mac会立即重启！！</span><br>
            11.重启之后，右上角会出现sep的图标（黄色小盾牌）：若出现小图标，则表示安装完成。<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic11.png" width=550px height=90px><br>
            <span style="font-size:25px;font-weight:bold;">四、注册结果查询</span><br><br>
            <div style="background:#F0FFF0">杀毒软件安装时，会提示填写mis账号，或通过资产信息识别使用者，可通过以下方式查看是否注册成功。</div>
            <br><br>
            <span style="font-size:20px;font-weight:bold;">1.注册结果查询</span><br><br>
            请到以下地址查询是否注册成功：<br>
            https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号<br>
            如图：<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic12.png" width=600px height=90px><br>
            如果出现 symantec: installed 字样，代表已经安装并成功注册。<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic13.png" width=600px height=90px><br>
            如显示symantec:uninstalled，说明未注册成功<br>
            未注册成功解决办法：请参考本wiki内的，
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="kmUrl('https://km.sankuai.com/page/18286751#id-2.%E6%9C%AA%E6%B3%A8%E5%86%8C%E6%88%90%E5%8A%9F')">未注册成功</span><br>
            <br>
            <span style="font-size:20px;font-weight:bold;">2.未注册成功</span><br><br>
            <div style="background:#FFF5EE"><span style="font-weight:bold">运行信息安全中心提供的注册工具，重新注册一下即可。<span
                    style="color:red">无须重新安装杀毒软件！</span></span><br>
                此工具请在连接MTDP网络状态下使用
            </div>
            <span style="font-weight:bold">①Mac</span><br>
            <div style="background:#FFF5EE">若您是Mac电脑，但是安装了Windows系统，请使用
                <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                      @click="kmUrl('https://km.sankuai.com/page/18286732#id-2.Windows%E6%9C%AA%E6%B3%A8%E5%86%8C%E6%88%90%E5%8A%9F')">Windows版工具</span>。
            </div>
            <br>
            1.请下载mac版工具：
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="kmUrl('https://share.neixin.cn/link/CK4vW683')">mac工具下载地址</span><br>
            2.下载后，解压文件到任意目录，<span style="color:red">一定要解压</span>，<br>
            3.运行之后，会自动打开浏览器并打开注册页面（如下图），<span style="color:red">需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面</span><br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic14.png" width=600px height=350px><br>
            4.若注册成功，页面显示如下：<br>
            <img src="../assets/saimenInstallForMac/saimenInstallForMac_pic15.png" width=550px height=250px><br>
            5.操作后请到以下地址查询是否注册成功（
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="kmUrl('https://km.sankuai.com/page/18286751#id-1.%E6%B3%A8%E5%86%8C%E7%BB%93%E6%9E%9C%E6%9F%A5%E8%AF%A2')">SEP查询注册结果使用方法</span>）<br>
            <table border=1 cellpadding=10 cellspacing=0 width="90%">
                <tr align=left style="background:#F5F5F5">
                    <th>代码块</th>
                </tr>
                <tr>
                    <td>https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号</td>
                </tr>
            </table>
            6.使用工具重新注册后请再次查询注册结果，如仍未注册成功的，请将【mis账号+软件安装成功的图标截图】提供给【6000帮助台】<br><br>
            <span style="font-size:25px;font-weight:bold;">五、常见问题FAQ</span><br><br>
            <span style="color:#0099FF">Q：我为什么要安装？不安装又会怎么样呢？</span><br>
            A：近半年来，公司办公网几乎每月都有多起病毒感染事件发生，导致电脑无法正常运行、电脑中的文件被删除、信息被窃取等，不仅影响自身办公，还可能病毒传播影响他人电脑，影响公司安全！<br>
            另外，根据公司制度规定，员工应做好本人使用和管理的计算机的防病毒工作，不得随意卸载防病毒软件或改变安全配置。若重新安装了计算机操作系统，应及时安装防病毒软件。<br><br>
            <span style="color:#0099FF">Q: 怎样区分我的电脑是否需要安装？</span><br>
            A：符合以下任意一个条件的电脑都需要安装，无论是自己买的电脑，还是公司配的。若有多台，均需安装。<br>
            &nbsp;&nbsp;1. 用于办公用途的电脑，包括但不限于:<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用浏览器登录使用任何公司web系统，包括但不限于web邮件、sankuai门户、HR平台等<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用outlook、apple mail等邮件客户端软件收发邮件<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用git等软件链接代码仓库进行开发工作<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;直接登录或跳板登录公司服务器<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;存储公司资料的机器<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其他<br>
            &nbsp;&nbsp;2. 接入公司网络<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过有线连接公司网络<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过无线连接公司网络<br><br>
            <span style="color:#0099FF">Q：安装了杀毒软件会对我的电脑造成什么影响？</span><br>
            A：公司采购的杀毒软件是国际知名安全厂商软件，已在各大公司有非常多年普及的经验。信息安全中心自Q1试点推广以来，低于1‰的员工可能遇到异常，包括电脑性能不足、蓝屏等，可能影响办公。当发生这些情况时，请及时联系6000或当地IT解决，或禁用、卸载。<br><br>
            <span style="color:#0099FF">Q：杀毒软件会做什么事情，会监控我的电脑吗？</span><br>
            A：杀毒软件的主要功能为防范电脑病毒、木马或恶意软件，保护终端安全。为了实现其安全功能，杀毒软件会检测系统运行的程序，使用不限于特征匹配等方式检测恶意程序；同时，杀毒软件也会监控网络流量，防止恶意攻击等。
            <span style="color:red">请大家放心，杀毒软件不会监控员工操作电脑行为、聊天记录、隐私数据等。</span>
            <br><br><br>
            <span style="color:red">如大家还有别的疑问，请及时反馈给我们，我们将及时为您解答。谢谢！</span><br>
            <br>
        </div>
    </div>
</template>

<script>
    import store from '../vuex/service/store'
    import axios from 'axios'
    import {mapState} from 'vuex';
    import util from '../views/util/commonUtil'

    export default {
        store: store,
        mounted: function () {
            var vm = this;
            if (vm.token == "") {
                var token = this.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            vm.getUser();
        },
        computed: mapState({
            loginRediret: function (state) {
                return state.loginRediret;
            },
            cookieName: function (state) {
                return state.cookieName;
            },
            getuserAPI: function (state) {
                return state.getuserAPI;
            }
        }),
        filters: {
            idcExplain(val) {
                return util.idcExplain(val)
            },
            timeFormat(val) {
                return util.timeFormat(val)
            },
            switchColor(val) {
                return util.switchColor(val)
            },
            statusExplain(val) {
                return util.statusExplain(val)
            }
        },
        methods: {
            reset() {

            },
            kmUrl(URL) {
                window.open(URL);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            getUser() {
                var vm = this;
                if (vm.user == null || vm.user == "") {
                    vm.user = vm.getCookie("username");
                    document.cookie = "ssoid=" + vm.getCookie("access-token");
                    axios.get(vm.getuserAPI, {
                        withCredentials: true
                    }).then((response) => {
                        if (response.data.status == 401) {
                            document.cookie = vm.cookieName + vm.$route.fullPath;
                            window.location = vm.loginRediret;
                        }

                    }).catch(function (error) {
                        vm.requesterrorinfo(error)
                    })
                }
            },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        vm.$message.error("401:您未登录");
                        var count = vm.getCookie("access-count")
                        window.location = vm.loginRediret;
                        if (count == null || count == 0) {
                            document.cookie = "access-count=1";
                            vm.$message('您未登录,请刷新');
                            document.cookie = vm.cookieName + vm.$route.fullPath;
                            window.location = vm.loginRediret;
                        } else {
                            vm.$message('您未登录,请刷新');
                        }
                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'

                    });
                }
            }
        },
        data() {
            return {
                hostname: '',
                token: '',
            }
        }
    }
</script>
<style>
    .select1 {
        width: 100px;
    }

    .select2 {
        width: 130px;
    }

    .select3 {
        width: 160px;
    }

    .input1 {
        width: 350px;
    }

    .input2 {
        width: 210px;
    }

    .demo-table-expand label {
        width: 140px;
        color: #5d94bf;
    }
</style>



// WEBPACK FOOTER //
// saimenInstallForMac.vue?18ab9a62